// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const SentinelOneIcon = createSvgIcon(
  <svg viewBox="0 0 1272 1589">
    <defs>
      <linearGradient
        id="sentinel-one_svgb"
        x2={1}
        gradientTransform="matrix(-631.364 -316.068 105.623 -210.989 1266.7 474.95)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#4500b6" />
        <stop offset={1} stopColor="#6100ff" />
      </linearGradient>
      <linearGradient
        id="sentinel-one_svgc"
        x2={1}
        gradientTransform="matrix(-631.364 316.07 -105.622 -210.984 1266.7 1113.72)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#4500b6" />
        <stop offset={1} stopColor="#6100ff" />
      </linearGradient>
      <linearGradient
        id="sentinel-one_svgd"
        x2={1}
        gradientTransform="matrix(631.363 -316.068 105.624 210.989 4.57 474.95)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#6100ff" />
        <stop offset={1} stopColor="#4500b6" />
      </linearGradient>
      <linearGradient
        id="sentinel-one_svge"
        x2={1}
        gradientTransform="matrix(631.363 316.07 -105.622 210.984 4.57 1113.72)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#6100ff" />
        <stop offset={1} stopColor="#4500b6" />
      </linearGradient>
      <linearGradient
        id="sentinel-one_svgf"
        x2={1}
        gradientTransform="matrix(-683.229 -342.062 105.672 -211.068 974.59 964)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#6100ff" />
        <stop offset={1} stopColor="#4500b6" />
      </linearGradient>
      <clipPath id="sentinel-one_svga" clipPathUnits="userSpaceOnUse">
        <path d="M-10.44 0h8396.73v1588.67H-10.44z" />
      </clipPath>
    </defs>
    <g clipPath="url(#sentinel-one_svga)">
      <path
        fill="url(#sentinel-one_svgb)"
        d="m635.6 318.4 635.6 317.8V317.8L635.6 0z"
      />
      <path
        fill="url(#sentinel-one_svgc)"
        d="m635.6 1270.2 635.6-317.7v318.4l-635.6 317.8z"
      />
      <path
        fill="url(#sentinel-one_svgd)"
        d="M635.6 318.4.1 636.2V317.8L635.6 0z"
      />
      <path
        fill="url(#sentinel-one_svge)"
        d="M635.6 1270.2.1 952.5v318.4l635.5 317.8z"
      />
      <path
        fill="url(#sentinel-one_svgf)"
        d="m158.9 715.1 635 317.6 318.3-159.3-634.8-317.3z"
      />
    </g>
  </svg>,
  "SentinelOne",
);
export default SentinelOneIcon;
